<!--
 * @Author: your name
 * @Date: 2020-03-03 11:06:46
 * @LastEditTime: 2020-04-02 17:25:23
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\src\components\icons\IconBase.vue
 -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <!-- <title :id="iconName" lang="en"></title> -->
    <title :id="iconName" lang="cmn">{{ iconName }}</title>
    <g :fill="iconColor">
      <slot />
    </g>
  </svg>
</template>

<script>
/**
 * @ref [可编辑的 SVG 图标系统](https://cn.vuejs.org/v2/cookbook/editable-svg-icons.html)
 */

export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    viewBox: {
      type: String,
      default: '0 0 18 18'
    },
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
  margin-bottom: -2px; /* yes, I'm that particular about formatting */
}
</style>
